export async function getBillingRecords(client_id = '', payment_status = '', start_date = '', end_date = '', payment_date='') {
    try {
        // API Base URL
        const baseUrl = 'https://ps5fjirz7c.execute-api.ap-southeast-1.amazonaws.com/prod/getBillingRecords';

        // Build query string based on provided parameters
        const queryParams = new URLSearchParams();

        if (client_id) {
            queryParams.append('client_id', client_id);
        }
        if (payment_status) {
            queryParams.append('payment_status', payment_status);
        }
        if (start_date) {
            queryParams.append('start_date', start_date);
        }
        if (end_date) {
            queryParams.append('end_date', end_date);
        }
        if (payment_date) {
            queryParams.append('payment_date', payment_date);
        }

        // Construct final API URL with query parameters
        const apiUrl = queryParams.toString() ? `${baseUrl}?${queryParams.toString()}` : baseUrl;

        // Make the API call
        const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        // Check for a successful response
        if (response.ok) {
            const data = await response.json();
            return data; // Return the fetched billing records
        } else {
            console.error(`Error: Failed to fetch billing records. Status: ${response.status}`);
            return null;
        }
    } catch (error) {
        // Catch any network or other errors
        console.error('Error: Network or other error occurred while fetching billing records.', error);
        return null;
    }
}

export async function getBillingRecord(id) {
    try {
        // Make the API call using the provided billing record ID
        const response = await fetch(`https://1k5d0h2tb2.execute-api.ap-southeast-1.amazonaws.com/prod/getBillingRecord/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        // Check for a successful response
        if (response.ok) {
            const data = await response.json();
            return data;  // Return the billing record data
        } else {
            console.error(`Error: Failed to fetch billing record. Status: ${response.status}`);
            return null;
        }
    } catch (error) {
        // Catch any network or other errors
        console.error('Error: Network or other error occurred while fetching the billing record.', error);
        return null;
    }
}




export async function postBillingRecord(billingRecordParameters = {}) {
    // Construct the payload with spread syntax
    const billingRecordPayload = {
        ...billingRecordParameters, // Spread all properties from billingRecordParameters
    };

    try {
        // Make the API call
        const response = await fetch('https://6bu5phzmgg.execute-api.ap-southeast-1.amazonaws.com/prod/postBillingRecord', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(billingRecordPayload),
        });

        // Check for a successful response
        if (response.ok) {
            return await response.json(); // Return the response as JSON
        } else {
            console.error(`Error: Failed to post billing record data. Status: ${response.status}`);
            return null;
        }
    } catch (error) {
        // Catch any network or other errors
        console.error('Error: Network or other error occurred while posting billing record data.', error);
        return null;
    }
}


export async function putBillingRecord(id, billingRecordParameters = {}) {
    // Prepare the payload for submission using the passed billingRecordParameters
    const submitData = {
        ...billingRecordParameters, // Spread all the properties from billingRecordParameters
    };

    try {
        console.log('Submitting updated billing record data:', submitData);

        const response = await fetch(`https://rqom0hj4n0.execute-api.ap-southeast-1.amazonaws.com/prod/putBillingRecord/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(submitData), // Convert the payload to JSON
        });

        const result = await response.json();

        if (response.ok) {
            console.log('Billing record updated successfully!', result);
            return { success: true, data: result };
        } else {
            console.error('Error updating billing record:', result);
            return { success: false, error: result };
        }
    } catch (error) {
        console.error('Network or other error occurred while updating billing record:', error);
        return { success: false, error };
    }
}
/* CONTRACTS APIs */
const CONTRACTS_API_BASE = 'https://9gzgn82nf9.execute-api.ap-southeast-1.amazonaws.com/default';

export async function postContractItem(clientId, billingContractParameters = {}) {
  try {
    const response = await fetch(
      `https://l0rwo4r42k.execute-api.ap-southeast-1.amazonaws.com/prod/clients/${clientId}/contracts`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(billingContractParameters),
      }
    );

    const result = await response.json().catch(() => null);

    if (!response.ok) {
      return {
        success: false,
        status: response.status,
        error: result || { error: "Unknown API error" },
      };
    }

    return { success: true, data: result };
  } catch (error) {
    return {
      success: false,
      error: { error: error.message || "Network error" },
    };
  }
}

export async function getContractsBulk(clientIds = []){
    try {
        const response = await fetch(
            `${CONTRACTS_API_BASE}/contracts/bulk`,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json'},
                body: JSON.stringify({ client_ids: clientIds }),
            }
        );
        if (response.ok) {
            const data = await response.json();
            return data.results ?? {};
        }
        console.error(`Error: Failed to fetch bulk contracts. Status: ${response.status}`)
        return {};
    } catch (error) {
        console.error(`Error: Network or other error occured while fetching bulk contracts`, error);
        return {};
    }
}

export async function getActiveContracts(limit = 200, cursor = '') {
    const params = new URLSearchParams({
        status: 'ACTIVE',
        limit: String(limit),
    });
    if (cursor) params.append('cursor', cursor);

    try {
        const response = await fetch(`${CONTRACTS_API_BASE}/contracts?${params.toString()}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        });

        if (response.ok) {
            return await response.json();
        }

        console.error(`Error: Failed to fetch active contracts. Status: ${response.status}`);
        return { items: [], next_cursor: null };
    } catch (error) {
        console.error('Error: Network or other error occurred while fetching active contracts.', error);
        return { items: [], next_cursor: null };
    }
}

export async function getContractItem(clientId, contractId = ''){
    try {
        let apiKey = `${CONTRACTS_API_BASE}/clients/${clientId}/contracts`;

        if (contractId) {
            apiKey += `/${contractId}`;
        }

        const response = await fetch(apiKey, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });
        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            console.error(`Error: Failed to fetch contract item. Stats: ${response.status}`);
            return null;
        }
    } catch (error) {
        console.error('Error: Network or another error occured while fectching contract item.', error);
    }
    
}

export async function patchContractItem(clientId, contractId, contractParameters = {}) {
    const contractPayload ={
        ...contractParameters,
    };
    console.log(JSON.stringify(contractPayload));
    try {
        const response = await fetch(`https://e8nfcujrce.execute-api.ap-southeast-1.amazonaws.com/prod/clients/${clientId}/contracts/${contractId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(contractPayload),
        });
        if (response.ok) {
            const result = await response.json();
            console.log('Contract updated successfully:', result);
            return result;
        } else { 
            const error = await response.json();
            console.error(`Error: Failed to update billing contract data. Status: ${response.status}`);
            console.error("Error body:", error);
            return null;
        }
    } catch (error) {
        console.error('Error: Network or other error occurred while updating billing contract data.', error);
        return null;
    }
}

export async function deleteContractItem(clientId, contractId, force = false) {
    try {
        console.log(force);
        const apiKey = new URL(`https://hj87yywlm2.execute-api.ap-southeast-1.amazonaws.com/prod/clients/${clientId}/contracts/${contractId}`)
        if (force) {
            apiKey.searchParams.append('force', 'true');
        }
        const response = await fetch(apiKey.toString(), {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            }
        });
        if (response.ok) {
            const result = await response.json();
            console.log('Contract deleted successfully:', result);
            return { success: true, data: result };
        } else {
            const error = await response.json();
            console.error(`Error: Failed to delete billing contract. Status: ${response.status}`);
            return { success: false, error };
        }
    } catch (error) {
        console.error('Error: Network or other error occured while deleting contract.', error);
        return { success: false, error};
    }
}

export async function postInvoiceItem(clientId, contractId, invoiceParameters = {}) {
    const invoicePayload = {
        ...invoiceParameters,
    }
    try {
        const response = await fetch(`https://k45wuh6c1g.execute-api.ap-southeast-1.amazonaws.com/prod/clients/${clientId}/contracts/${contractId}/invoices`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(invoicePayload),
        });
        if (response.ok) {
            return await response.json();
        } else {
            console.error('Error: Failed to post invoice item.');
            return null;
        } 
    } catch (error) {
        console.error('Error: Network or other error occured while posting invoice item.', error);
        return null;
    }
}

export async function getInvoicesByClientId(clientId, filters = {}, signal = null) {
    const apiKey = `https://oa1epow7mf.execute-api.ap-southeast-1.amazonaws.com/prod/clients/${clientId}/invoices`
    const params = new URLSearchParams();

    if (filters.status) {
        params.append('status', filters.status.toUpperCase());
    }
    if (filters.billing_start) {
        params.append('billing_start', filters.billing_start);
    }
    if (filters.billing_end) {
        params.append('billing_end', filters.billing_end);
    }
    if (filters.payment_start) {
        params.append('payment_start', filters.payment_start);
    }
    if (filters.payment_end) {
        params.append('payment_end', filters.payment_end);
    }
    if(filters.limit){
        params.append('limit', String(filters.limit));
    }
    if (filters.cursor) {
        params.append('cursor', filters.cursor);
    }

    const queryString = `${params.toString()}`;
    const url = queryString ? `${apiKey}?${queryString}` : apiKey;

    console.log('api used:', url);

    try {
        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                ...(signal ? { signal } : {}),
            }
        );
        if(response.ok) {
            const data = await response.json();
            console.log('Invoices fetched successfully:', data);
            return data;
        } else {
            const err = await response.text();
            console.error('Error: Failed to fetch invoices:', response.status, err);
            return [];
        }
    } catch (error) {
        if (error.name === 'AbortError') throw error;
        console.error('Error: Network or other error occured while fetching invoices.', error);
        return [];
    }
}

export async function getInvoicesByContractId(contractId, filters={}){
    const apiKey = `https://oa1epow7mf.execute-api.ap-southeast-1.amazonaws.com/prod/contracts/${contractId}/invoices`
    const params = new URLSearchParams();

    if (filters.status) {
        params.append("status", filters.status.toUpperCase());
    }
    if (filters.billing_start) {
        params.append("due_start", filters.due_start);
    }
    if (filters.billing_end) {
        params.append("due_end", filters.due_end);
    }
    if(filters.limit){
        params.append("limit", String(filters.limit));
    }
    if (filters.cursor) {
        params.append("cursor", filters.cursor);
    }

    const queryString = `${params.toString()}`;
    const url = queryString ? `${apiKey}?${queryString}` : apiKey;

    try {
        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        );
        if(response.ok){
            const data = await response.json();
            console.log('Invoices fetched successfully:', data);
            return data;
        } else {
            console.error('Error: Failed to fetch invoices.');
            return [];
        }
    } catch (error) {
        console.error('Error: Network or other error occured while fetching invoices.', error);
        return [];
    }
}

export async function deleteInvoiceItem(contractId, billingDate, invoiceId, force = false){
    try {
        const apiKey = new URL(`https://1ta5p198dg.execute-api.ap-southeast-1.amazonaws.com/prod/contracts/${contractId}/invoices/${billingDate}/${invoiceId}`)
        
        if (force) {
            apiKey.searchParams.append('force', 'true');
        } 

        const response = await fetch(apiKey, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                }
        });
        
        if (response.ok) {
            const result = await response.json();
            console.log('Invoice deleteed successfully:', result);
            return { success: true, data: result };
        } else {
            const error = await response.json();
            console.error(`Error: Failed to delete invoice. Status: ${response.status}`);
            return { success: false, error };
        }
    } catch (error) {
        console.error('Error: Network or other error occurred while deleting invoice.', error);
        return { success: false, error };
    }
}

export async function patchInvoiceItem(invoiceId, invoiceData){
    try {
        console.log('InvoiceData: ', invoiceData);
        const contractId = invoiceData.contract_id;
        const billingDate = invoiceData.billing_date;
        const apiKey = `https://6fy3ptjx8h.execute-api.ap-southeast-1.amazonaws.com/prod/contracts/${contractId}/invoices/${billingDate}/${invoiceId}`

        const response = await fetch(apiKey, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(invoiceData),
        });

        if (response.ok) {
            console.log('api used: ', apiKey);
            const result = await response.json();
            console.log('Invoice updated successfully:', result);
            return result;
        } else {
            const error = await response.json();
            console.error(`Error: Failed to update contract Invoice data. Status: ${response.status}`);
            console.error('Error body:', error);
            return null;
        }
    } catch (error) {
        console.error('Error: Network or other error occurred while updating contract invoice data.', error);
        return null;
    }
};

export async function getAllInvoices(filters = {}, signal = null) {
    const baseUrl = 'https://oa1epow7mf.execute-api.ap-southeast-1.amazonaws.com/prod/invoices';
    const params = new URLSearchParams();

    if (filters.status) params.append('status', filters.status.toUpperCase());
    if (filters.billing_start) params.append('billing_start', filters.billing_start);
    if (filters.billing_end) params.append('billing_end', filters.billing_end);
    if (filters.payment_start) params.append('payment_start', filters.payment_start);
    if (filters.payment_end) params.append('payment_end', filters.payment_end);
    if (filters.limit) params.append('limit', String(filters.limit));
    if (filters.cursor) params.append('cursor', filters.cursor);

    const url = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            ...(signal ? { signal } : {}),
        });
        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            console.error(`Error: Failed to fetch all invoices. Status: ${response.status}`);
            return [];
        }
    } catch (error) {
        if (error.name === 'AbortError') throw error;
        console.error('Error: Network or other error occurred while fetching all invoices.', error);
        return [];
    }
}

export async function getInvoiceSummary() {
    const url = 'https://oa1epow7mf.execute-api.ap-southeast-1.amazonaws.com/prod/invoices/summary';
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        });
        if (response.ok) return await response.json();
        console.error(`Error: Failed to fetch invoice summary. Status: ${response.status}`);
        return null
    } catch (error) {
        console.error('Error: Network error fetching invoice summary.', error);
        return null;
    }
}

export async function getInvoicesByClientIds(clientIds, filters = {}, signal = null) {
    const results = await Promise.all(
        clientIds.map(id => getInvoicesByClientId(id, filters, signal))
    );
    return results.flatMap(r => r?.items ?? r?.invoices ?? (Array.isArray(r) ? r : []));
}
